import { UploadOutlined } from '@ant-design/icons';
import { Button, Upload } from 'antd';
import React, { useEffect } from 'react';
import { REGEX } from '../common/constants';

const EnvFileUploader = ({
  fileContent,
  setFileContent,
  editingKey,
  setEditingKey,
  setError,
  selectedBranch,
}) => {
  const edit = (record) => {
    if (!editingKey.includes(record.key)) {
      setEditingKey((prev) => [...prev, record?.key]);
    }
  };

  const beforeUpload = (file) => {
    setFileContent([]);
    setError('');
    // eslint-disable-next-line no-undef
    const reader = new FileReader();

    reader.onload = (e) => {
      const text = e?.target?.result;
      const lines = text?.split('\n')?.map((line) => line?.trim());

      if (!lines || lines?.every((line) => !line || line?.startsWith('#'))) {
        setError('Empty file is not supported.');
        setFileContent([]);
        return;
      }

      const envs = [];
      let hasEmptyKey = false;
      let isFormatError = false;

      lines?.forEach((line) => {
        if (isFormatError) return;
        if (!line || line?.startsWith('#')) return;

        if (!line?.includes('=')) {
          isFormatError = true;
          return;
        }

        const [key, value] = line?.split('=');

        if (!key) {
          hasEmptyKey = true;
        } else {
          envs?.push({
            key: key?.trim(),
            value: value?.trim(),
            isValid: REGEX?.ENV_KEY?.test(key?.trim()),
            isPrivate: false,
          });
        }
      });
      if (isFormatError) {
        setError('Please upload file in env format only!');
        setFileContent([]);
      } else if (hasEmptyKey) {
        setError('Key is required.');
        setFileContent([]);
      } else {
        setFileContent(envs);
      }
    };

    reader.onerror = () => {
      setFileContent([]);
      return setError('error uploading env file.');
    };

    reader.readAsText(file);
    return false;
  };

  useEffect(() => {
    if (fileContent.length > 0) {
      const invalidItems = fileContent?.filter((item) => !item?.isValid);
      const initialEditingKeys = invalidItems?.map((item) => item?.key);
      setEditingKey(initialEditingKeys);
      invalidItems?.forEach((item, index) => {
        edit(item, index);
      });
    }
  }, [fileContent]);

  return (
    <>
      <Upload
        showUploadList={false}
        beforeUpload={beforeUpload}
        onRemove={() => setFileContent([])}
      >
        <Button
          icon={<UploadOutlined />}
          type="primary"
          disabled={selectedBranch <= 0}
        >
          Click to Upload
        </Button>
      </Upload>
    </>
  );
};

export default EnvFileUploader;
